module.exports = __webpack_public_path__ + "media/images/icon-benefits-optical-4e7f5022ee3f4cc78d55fac80536a17a.png";